import { render, staticRenderFns } from "./SettingsPaymentMethodForm.vue?vue&type=template&id=d74dfc22"
import script from "./SettingsPaymentMethodForm.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentMethodForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports